<template>
    <div>
        <Snackbar v-if="errored" msg="Error from Server" />
        <Snackbar v-if="created" msg="Operation Successfull" />
        <v-card-title>New Member</v-card-title>
        <v-col cols="12">
        <v-form ref="form" v-model="valid">
            <v-container>
            <v-row>
                <v-col
                cols="5"
                >
                    <v-text-field
                        v-model="fullName"
                        :rules="fullNameRules"
                        :loading="loading"
                        label="Full Name*"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                cols="4"
                >
                    <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        :loading="loading"
                        label="Email"
                        required
                    ></v-text-field>
                </v-col>                
                <v-col
                cols="3"
                >
                    <v-file-input
                        :rules="imageRules"
                        v-model="image"
                        show-size
                        accept="image/*"
                        label="Member photo"
                        clearable
                    ></v-file-input>
                </v-col>
                <v-col
                cols="2"
                >
                    <v-checkbox
                    v-model="active"
                    label="Active Member"
                    ></v-checkbox>
                </v-col>
                <v-col
                cols="3"
                >
                <v-dialog
                    ref="dialogStartDate"
                    v-model="modalStart"
                    :return-value.sync="startDate"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="startDate"
                        label="Start date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="startDate"
                    scrollable
                    :first-day-of-week="1"
                    locale="es-ES"
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="modalStart = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.dialogStartDate.save(startDate)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-dialog>
                </v-col>
                <v-col
                cols="3"
                >
                <v-dialog
                    ref="dialogEndDate"
                    v-model="modalEnd"
                    :return-value.sync="endDate"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="endDate"
                        label="End date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :disabled="active"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                    v-model="endDate"
                    scrollable
                    :first-day-of-week="1"
                    locale="es-ES"
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="modalEnd = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.dialogEndDate.save(endDate)"
                    >
                        OK
                    </v-btn>
                    </v-date-picker>
                </v-dialog>
                </v-col>                
                <v-col
                cols="4"
                >
                    <v-text-field
                        v-model="link"
                        :rules="linkRules"
                        :loading="loading"
                        label="Personal page URL"
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-select
                    :rules="projectRules"
                    :items="items"
                    :loading="loading"
                    :disabled="loading"
                    item-text="name"
                    label="Select a project"
                    dense
                    return-object
                    multiple
                    chips
                    v-model="project"
                    ></v-select>

                </v-col>
                <v-col cols="4">
                    <v-select
                    :rules="categoryRules"
                    :items="categories"
                    :loading="loading"
                    :disabled="loading"
                    item-text="name"
                    label="Select a category"
                    dense
                    return-object
                    multiple
                    chips
                    v-model="category"
                    ></v-select>

                </v-col>
                <v-col
                cols="4"
                >
                <v-text-field
                    v-model="degree"
                    :rules="degreeRules"
                    :loading="loading"
                    label="Degree"
                    required
                ></v-text-field>
                </v-col>
                <v-col
                cols="12"
                >
                <v-textarea
                    counter
                    v-model="description"
                    :loading="loading"
                    rows="3"
                    label="Description*"
                    required
                ></v-textarea>
                </v-col>
                <v-col>
                    <v-btn
                        depressed
                        :disabled="loading"
                        :loading="loading"
                        color="primary"
                        class="mr-4"
                        @click="submit"
                        >
                        Submit
                    </v-btn>
                </v-col>
            </v-row>
            </v-container>
        </v-form>
        </v-col>
    </div>
</template>
<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'

export default {
    title: 'NewMember',
    components: {
        Snackbar
    },
    data: () => ({
        valid: false,
        loading: false,
        errored: false,
        created: false,
        modalStart: false,
        modalEnd: false,        
        items: [],
        categories: [],
        image: null,
        fullName: '',
        degree: '',
        project: [],
        active: true,
        category: [],
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
        description: '',
        link: '',
        email: '',
        fullNameRules: [
            v => !!v || 'Full Name is required'
            // v => v.length <= 10 || 'title must be less than 10 characters',
        ],
        degreeRules: [
            v => !!v || 'Degree is required'
        ],
        startDateRules: [
            v => !!v || 'Date is required'
        ],
        categoryRules: [
            v => v.length > 0 || 'Must have one category'
        ],
        emailRules: [
            v => v && v.length > 0 ? /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Not a valid Email' : true
        ],
        projectRules: [
            v => !!v || 'Project is required'
            // v => v.length <= 10 || 'title must be less than 10 characters',
        ],
        imageRules: [
            value => !value || value.size < 500000 || 'Image size should be less than 500 KB!'
        ],
        linkRules: [
            v => (!v || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(v)) || 'Must be a valid link'
        ],
    }),
    mounted() {
        this.loading = true
        axios
            .get(`/category/?section=Member`)
            .then((res) => {
                this.categories = res.data.data
            })
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
            })
        axios
            .get(`/project/`)
            .then(res => {
                this.items = res.data.data
                this.loading = false
            })
            .catch(err => {
                console.error("axios err", err)
                this.errored = true
                this.loading = false
            })
    },
    methods: {
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const fr = new FileReader()
                fr.readAsDataURL(file);
                fr.onload = () => resolve(fr.result);
                fr.onerror = error => reject(error);
            })
        },
        async submit () {
            this.errored, this.created = false
            if(this.$refs.form.validate()){
                this.loading = !this.loading;
                let {fullName, degree, project, image,
                        active, startDate, endDate, description, link,
                        email, category} = this;
                let data = {
                        fullName, 
                        degree,
                        projectsIds: project.map(p => p._id),
                        category: category.map(c => c._id),
                        active,
                        startDate,
                        endDate,
                        description,
                        link,
                        email
                }
                if(active){
                    data['endDate'] = null;
                }
                if(image){
                    let fileToBase64 = await this.toBase64(image)
                    data['image'] = fileToBase64
                }
                axios.post(`/member/`, data)
                    .then(() => {
                        this.created = true
                        this.$refs.form.reset()
                    })
                    .catch(err => {
                        console.error("error", err)
                        this.errored = true
                    })
                    .finally(() => {
                        this.loading = false
                    });
            }
        },
		reset () {
			this.$refs.form.reset();
        }        
    }
}
</script>